import type { ReactNode } from "react";
import { FormikError } from "components/shared/FormikError";
import { useSchoolLocal } from "../useSchoolLocal";
import type { Keys } from "./formik";

export const fieldInputClassName =
  "w-full rounded-xl border border-[#D5DAE6] bg-white px-3.5 py-3 text-[15px] text-[#2E2E38] outline-none transition focus:border-[#4242CE] focus:ring-2 focus:ring-[#4242CE]/35";

type FieldShellProps = {
  name: Keys;
  label: string;
  required: boolean;
  children: ReactNode;
};

// Label, required/optional marker and validation error shared by every form control.
export const FieldShell = ({
  name,
  label,
  required,
  children,
}: FieldShellProps) => {
  const { t } = useSchoolLocal();

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={name} className="text-[13px] font-semibold">
        {label}{" "}
        {required ? (
          <span className="text-[#4242CE]">*</span>
        ) : (
          <span className="font-medium text-[#828282]">
            {t("connect.optional")}
          </span>
        )}
      </label>
      {children}
      <FormikError<Keys> name={name} />
    </div>
  );
};
